import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import Store from 'store/store';
import 'store/bolt/header';
import { accessNested } from 'utils/utils';

export default class Header extends BaseComp.default {
	getCurrentHeaderAction() {
		let actions = this.props.headerData.actions;
		const quizPhotobooth = Store.get().quizPhotobooth;
		const sequence = quizPhotobooth?.sequence;
		const shouldBeReset = (sequence?.includes('photobooth') && quizPhotobooth?.step === 'photobooth') || (!sequence?.includes('photobooth') && quizPhotobooth?.step === 'shareable');
		if (quizPhotobooth?.step === 'quiz' && quizPhotobooth?.question !== 0) {
			return {
				icon: 'back',
				action: () => Store.emit('QUIZPHOTOBOOTH_PREV_QUESTION', true),
				hidden: false
			};
		} else if (shouldBeReset) {
			return {
				icon: 'reset',
				action: () => {
					Store.emit('QUIZPHOTOBOOTH_QUIZ_RESET', true);
					Store.emit('QUIZPHOTOBOOTH_BACK_TO_INTRO', true);
				},
				hidden: false
			};
		} else if (quizPhotobooth?.step && quizPhotobooth?.step !== 'landing') {
			return {
				icon: 'back',
				action: () => Store.emit('QUIZPHOTOBOOTH_BACK', true),
				hidden: false
			};
		}
		return actions[actions.length - 1] || {
			icon: 'burger',
			action: this.openNavMenu
		};

	}

	getCurrentActionBtnAction(homeEntOpen) {
		let hidden = false;
		try {
			const { appData } = this.props;
			const previewPanelReplacingHomePage = appData?.pages.boltPreviewPanel && !appData?.pages.boltHome;
			hidden = !Object.values(appData.pages).find(page => {
				return page && !page.type && !page.section && (page.page === 'home');
			}) && !previewPanelReplacingHomePage;
		} catch (e) { }

		if (homeEntOpen) {
			return {
				icon: 'close',
				action: () => Store.emit('HOMEENT_HIDE', true),
				hidden
			};
		}

		const store = Store.get();

		if (store.widgetFullyExpanded) {
			return {
				icon: 'close',
				action: () => Store.emit('EXIT_WIDGET', true),
				hidden: false
			};
		}

		if (store.pressKit?.show) {
			return {
				icon: 'close',
				action: () => Store.emit('PRESSKIT_HIDE', true),
				hidden: false
			};
		}

		const quizPhotobooth = Store.get().quizPhotobooth;
		const sequence = quizPhotobooth?.sequence;
		const shouldBeReset = (sequence?.includes('photobooth') && quizPhotobooth?.step === 'photobooth') || (!sequence?.includes('photobooth') && quizPhotobooth?.step === 'shareable');
		if (quizPhotobooth?.step === 'quiz' && quizPhotobooth?.question !== 0) {
			return {
				icon: 'back',
				action: () => Store.emit('QUIZPHOTOBOOTH_PREV_QUESTION', true),
				hidden: false
			};
		} else if (shouldBeReset) {
			return {
				icon: 'back',
				action: () => {
					Store.emit('QUIZPHOTOBOOTH_QUIZ_RESET', true);
					Store.emit('QUIZPHOTOBOOTH_BACK', true);
				},
				hidden: false
			};
		} else if (quizPhotobooth?.step && quizPhotobooth?.step !== 'landing') {
			return {
				icon: 'back',
				action: () => Store.emit('QUIZPHOTOBOOTH_BACK', true),
				hidden: false
			};
		}

		const actions = accessNested(store, 'showtimes.actions', []);
		let lastAction = actions[actions.length - 1];
		if (lastAction) {
			return lastAction;
		}
		// Default action
		return {
			icon: 'close',
			action: () => Store.emit('SHOWTIMES_HIDE', true),
			hidden
		};
	}
}
